export default "__VITE_ASSET__DCiT$8I4__"